import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-parkeerkaart',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconParkeerkaart {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M18.5 11h-1.49V8h1.49c.25 0 1.49.07 1.49 1.5 0 1.33-1.05 1.49-1.49 1.5m-7.34-.09c-.04-.32-.07-.64-.07-.96C11.09 6.12 14.2 3 18.03 3s6.94 3.12 6.94 6.95c0 .33-.03.65-.07.96 0 .06-.02.12-.03.18-.03.17-.06.33-.1.49-1.1 5.28-6.74 12.27-6.74 12.27s-5.64-6.98-6.74-12.27c-.04-.16-.07-.32-.1-.49 0-.06-.02-.12-.03-.18M15.02 15c0 .55.44 1 .99 1s.99-.45.99-1v-2h1.49c1.4 0 3.48-.93 3.48-3.5S19.89 6 18.49 6H16c-.55 0-.99.45-.99 1v8Zm9.27 3c-2.05 3.74-4.55 6.88-4.71 7.08l-.78.97a1 1 0 0 1-1.55 0l-.78-.97c-.16-.2-2.66-3.33-4.71-7.08H6.02L.57 31.63c-.26.66.22 1.37.92 1.37h27.83c.41 0 .77-.25.92-.63l5.17-13a.998.998 0 0 0-.92-1.37H24.27Z"/>
</svg>

    );
  }
}
